// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "intake_submission".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { consentFormSubmissionStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "intake_submission" table (1:1 with a DB row, on the wire). */
export const intakeSubmissionAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    intakeFormId: z.string(),
    leadId: z.string(),
    appointmentId: z.string().nullable(),
    status: z.enum(consentFormSubmissionStatusValues),
    tokenHash: z.string().nullable(),
    fieldsSnapshot: z.unknown(),
    answers: z.unknown(),
    sentAt: z.string().datetime().nullable(),
    completedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=intakeSubmission.js.map